<!-- 中间title -->
<template>
    <div class='bg box box_between'>
        <div class="numberbg box ac">
            <div class="title title1">幼升小申请数</div>
            <div class="subtitle subtitle1" v-if="userCount">{{userCount}}<span style="font-size:13px">人</span></div>
        </div>
        <div class="numberbg box ac">
            <div class="title title2">五升六申请数</div>
            <div class="subtitle subtitle2" v-if="collectCount">{{collectCount}}<span style="font-size:13px">人</span></div>
        </div>
        <div class="numberbg box ac">
            <div class="title title3">小升初申请数</div>
            <div class="subtitle subtitle3"  v-if="resolveCount">{{resolveCount}}<span style="font-size:13px">人</span></div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            userCount:0,
            collectCount:0,
            resolveCount:0,
            companyCount:0,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.totalCount).then(res=>{
                //meetingCount
                this.userCount = res.rows[0].userCount.toLocaleString()
                this.collectCount = res.rows[0].collectCount.toLocaleString()
                this.resolveCount = res.rows[0].resolveCount.toLocaleString()
                this.companyCount = res.rows[0].companyCount.toLocaleString()

            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/estate/middle1.png');
    background-size: 100% 100%;
    height:120px;
    align-items: center;
    padding:0 10px;
}
.numberbg{
    margin:0 10px;
    width:100%;
    height:88px;
    background-image: url('../../../../assets/images/monitorpy/numberbg.png');
    background-size: 100% 100%;
    justify-content: center;flex-direction: column;
}
.title{
    font-size: 16px;
    text-align: center;
}
.title1{
    color:#01C3FF
}
.title2{
    color:#00F9E0
}
.title3{
    color:#EFDF83
}

.subtitle{
    font-size: 26px;
    font-style: italic;
    color: #09D4FF;
    text-align: center;
    font-weight: bold;
}
.subtitle1{
    background: linear-gradient(180deg, #00F6FF 0%, #0290FE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.subtitle2{
   background: linear-gradient(180deg, #00F6FF 0%, #00FF90 100%);
   -webkit-background-clip: text;
   -webkit-text-fill-color: transparent;
}
.subtitle3{
    background: linear-gradient(180deg, #FFA82B 0%, #E3D87C 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}


</style>
